import { Component, OnInit, effect, signal } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { ProprieteAffichee } from '../../../bo/proprieteAffichee';
import { FonctionsService } from '../../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../../services/utilisateur.service';
import { AddUsersToSiteModaleComponent } from '../../add-users-to-site-modale/add-users-to-site-modale.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { KeycloakUtilisateur, UserDtoLight } from 'src/app/bo/user/user';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';

@Component({
  selector: 'app-site-users',
  templateUrl: './site-users.component.html',
  styleUrls: ['./site-users.component.scss'],
  standalone: false
})
export class SiteUsersComponent implements OnInit {
  proprietesAfficheesUtilisateurs: ProprieteAffichee[] = [];
  tabUtilisateurs = signal<UserDtoLight[]>([]);
  modale: BsModalRef;
  erreurRecuperation = signal(false);

  constructor(private readonly modalService: BsModalService,
     private readonly http: HttpService, 
     private readonly fonctionsService: FonctionsService,
     private readonly keycloakService: KeycloakUtilisateurService,
      private readonly userService: UtilisateurService) {
    effect(() => { this.userService.currentSite(); this.refresh(); });
  }

  ngOnInit() {
    this.modalService.onHide.observers = [];
    this.modalService.onHide.subscribe((val: any) => {
      this.refresh()
    });
    this.proprietesAfficheesUtilisateurs = new KeycloakUtilisateur().getProprietesAfficheesWithoutRole();
    this.refresh();
  }

  refresh() {
    this.erreurRecuperation.set(false);
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    this.keycloakService.getSiteUsers(this.userService.currentSite().siteId)
    .then(resultat => {
      this.tabUtilisateurs.set(resultat);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    }, (error) => {
      console.error(error);
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    });
  }

  openAddModal() {
    const initialState = 
    { 
      action: 'add',
      usersList: signal(this.tabUtilisateurs())
    };
    this.modale = this.modalService.show(AddUsersToSiteModaleComponent, { initialState, backdrop: 'static' });
  }

  openDeleteModal() {
    const initialState =
    {
      action: 'delete',
      usersList: signal(this.tabUtilisateurs())
    };
    this.modale = this.modalService.show(AddUsersToSiteModaleComponent, { initialState, backdrop: 'static' });
  }
}
